import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-46609c12"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "tit"
};
const _hoisted_6 = {
  class: "money"
};
import { addImpression } from "@/utils/sensors-inject.js";
import { ref, watch } from 'vue';
import { useExposureObserver } from "@/utils/useExposureObserver";
export default {
  props: {
    item: Object,
    index: Number
  },
  setup(__props, {
    expose
  }) {
    const props = __props;

    // 万
    const formatMoney = amount => {
      return amount > 10000 ? (amount / 10000).toFixed(2) + '万' : amount;
    };
    const proItem = ref(null);
    // 2. 调用 useExposureObserver Composable
    // 将 targetElement ref 传递给 Composable，以及其他配置
    const {
      isIntersecting,
      isExposed,
      reobserve
    } = useExposureObserver(proItem,
    // 传入要观察的 DOM 元素的 ref
    {}, false // 传递 `once` 属性
    );
    // 3. 监听 `isExposed` 状态的变化，执行你“曝光到点”的业务逻辑
    watch(isExposed, newVal => {
      if (newVal) {
        addImpression({
          item_id: props.item.pro_id,
          category: props.item.category,
          sec_business_line: "101",
          page_source: "品类月",
          module: "热门众筹",
          module_position: props.index
        });
      }
    });

    // 如果父组件需要访问 `reobserve` 或其他内部状态，可以使用 `defineExpose` 暴露出去
    expose({
      reobserve,
      isExposed,
      isIntersecting
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        ref_key: "proItem",
        ref: proItem
      }, [props.index == 1 ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        class: "rank",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/category_month/category_month_index_first.png', 47)
      }, null, 8, _hoisted_1)) : props.index == 2 ? (_openBlock(), _createElementBlock("img", {
        key: 1,
        class: "rank",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/category_month/category_month_index_second.png', 47)
      }, null, 8, _hoisted_2)) : props.index == 3 ? (_openBlock(), _createElementBlock("img", {
        key: 2,
        class: "rank",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/category_month/category_month_index_third.png', 47)
      }, null, 8, _hoisted_3)) : _createCommentVNode("", true), _createElementVNode("img", {
        class: "logo",
        src: _ctx.$imgUrlFilter(props.item.logo, 230)
      }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, _toDisplayString(props.item.title), 1), _createElementVNode("div", _hoisted_6, "已筹 ￥" + _toDisplayString(formatMoney(props.item.backer_money)), 1)], 512);
    };
  }
};